/** @format */

import React, { useMemo } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const PieChart = React.memo(({ d1, d2, d3, d4 }) => {
  const values = useMemo(() => [d1, d4, d3, d2], [d1, d2, d3, d4]);

  const data = useMemo(
    () => ({
      labels: [
        `Samarqand - ${d1}`,
        `Navoiy - ${d4}`,
        `Qashqadaryo - ${d3}`,
        `Jizzax - ${d2}`,
      ],
      datasets: [
        {
          label: "Hududlar bo‘yicha taqsimot",
          data: values,
          backgroundColor: [
            "#4F46E5",
            "#06B6D4",
            "#10B981",
            "#F59E0B",
            "#EF4444",
            "#8B5CF6",
          ],
          borderWidth: 0,
        },
      ],
    }),
    [values, d1, d2, d3, d4]
  );

  const options = useMemo(
    () => ({
      responsive: true,
      plugins: {
        legend: { position: "right" },
        title: { display: false },
        datalabels: {
          color: "#fff",
          labels: {
            title: { font: { weight: "bold", size: 16 } },
          },
        },
      },
    }),
    []
  );

  return (
    <div
      className='pie-box'
      style={{
        height: "400px",
      }}>
      <Pie data={data} options={options} />
    </div>
  );
});

export default PieChart;
